import { createTheme } from '@mantine/core';
import { components } from './components';
import { brandColors, darkColors, layout, radii, typography } from './tokens';

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  colors: {
    brand: brandColors,
    dark: darkColors,
  },
  fontFamily: typography.fontFamily,
  headings: {
    fontFamily: typography.fontFamily,
    sizes: {
      h1: { fontSize: typography.h1, fontWeight: '800', lineHeight: '1.02' },
      h2: { fontSize: typography.h2, fontWeight: '800', lineHeight: '1.02' },
      h3: { fontSize: typography.h3, fontWeight: '700', lineHeight: '1.2' },
    },
  },
  defaultRadius: 'md',
  radius: radii,
  other: { layout },
  components,
});
